import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownModule } from 'ngx-markdown';
import { AccordionModule } from 'primeng/accordion';
import { LogService } from '@bioconnect-ui/log-service';
import { FAQs, SupportService } from '@bioconnect-ui/support-service';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MarkdownModule,
    AccordionModule
  ],
  selector: 'bioconnect-ui-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpComponent implements OnInit {
  faqs: FAQs[] = [];
  selectedAnswer = "";
  selectedQuestion = "";
  docLink = "https://docs.bioconnect.jax.org/";

  constructor(
    private supportService: SupportService,
    private logService: LogService,
    private cdr: ChangeDetectorRef,
  ) { }

  selectFAQ(selectedQuestion: string) {
    this.logService.logEvent('faq click', 
      {
          question: selectedQuestion
      }
    )
  }

  onNavigate(link: string) {
    window.open(link, "_blank");
  }

  ngOnInit(): void {
    this.supportService
      .getFAQs()
      .subscribe((faqs) => {
        this.faqs = faqs;
        this.cdr.markForCheck();
      });
  }
}
